import React from "react";
import { Route, Redirect } from "react-router-dom";

const PrivateComponent = ({ component: Component, token: Token, ...rest }) => {
    return (
        <Route
            {...rest}
            render={(props) =>
                Token === true ? (
                    <Component {...props} />
                ) : (
                    <Redirect
                        to={{
                            pathname: "/management",
                            state: { from: props.location },
                        }}
                    />
                )
            }
        />
    );
};

export default PrivateComponent;
